namespace advisorop.components.advisor {

    export class SalesforceCaseTrackerSummaryAdvisorController {
        // original data arrays
        totalUrl: string = "";
        byTypeUrl: string = "";
        newSalesforceCases: domains.ISalesforceCaseTrackerData[] = [];
        recordTypesSet: Set<string> = new Set<string>(["Total"]);
        recordTypes: string[] = [];
        public totalProposedValue: number = 0;
        public totalProposedValuesByType: Map<string, number> = new Map<string, number>([["Total", 0]]);
        public totalCountsByType: Map<string, number> = new Map<string, number>([["Total", 0]]);

        public filterByAdvisor = 1;
        // loading panel indicator
        loading = true;

        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#accountPipeline" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading cases from Salesforce...",
            bindingOptions: {
                visible: "vm.loading"
            }
        };

        static $inject = ["generalService", "advisorService", "$rootScope"];
        constructor(private gs: advisorop.services.GeneralService,
            private as: advisorop.services.AdvisorService,
            private $rootScope: ng.IRootScopeService) {

            this.setFilterByAdvisor();

            this.$rootScope.$on('adminModeChanged', (event: ng.IAngularEvent) => {
                this.setFilterByAdvisor();
                this.loadNewAccountLifeCycle();
            });

            // A case added from the grid below belongs in these totals straight away.
            this.$rootScope.$on("salesforceCaseCreated", () => this.loadNewAccountLifeCycle());
        }

        setFilterByAdvisor() {
            const adminMode = this.as.getAdminMode();
            this.filterByAdvisor = (adminMode && adminMode.enabled) ? 0 : 1;
        }

        loadNewAccountLifeCycle() {
            this.loading = true;
            this.as.getSalesforceOpenCases(this.filterByAdvisor == 1)
                .then(
                    resp => {
                        this.totalUrl = resp.data.totalUrl;
                        this.byTypeUrl = resp.data.byTypeUrl;
                        this.newSalesforceCases = resp.data.cases;
                        this.newSalesforceCases.forEach((x) => this.recordTypesSet.add(x.recordType));
                        if (this.newSalesforceCases.length > 0) {
                            this.recordTypesSet.forEach((r) => {
                                var numberOfCases = 0;
                                var value = this.newSalesforceCases.reduce(function (prev, cur) {
                                    let x = prev;
                                    if (cur.recordType == r) {
                                        x += cur.funding_Amount__c;
                                        numberOfCases++;
                                    }
                                    return x;
                                }, 0);
                                this.totalProposedValuesByType.set(r, value);
                                this.totalCountsByType.set(r, numberOfCases);
                                if (this.recordTypesSet.size > 1) {
                                    this.totalProposedValuesByType.set("Total", this.newSalesforceCases.reduce(function (prev, cur) {
                                        let x = prev + cur.funding_Amount__c;
                                        return x
                                    }, 0));
                                    this.totalCountsByType.set("Total", this.newSalesforceCases.length);
                                }
                            })
                        }
                        //else {
                        //this.totalProposedValuesByType.set("Total", 0);
                        //this.totalCountsByType.set("Total", 0);
                        //}
                        this.recordTypes = Array.from(this.recordTypesSet);
                        console.log(this.recordTypes);
                    },
                    err => this.gs.showError(err))
                .finally(() => this.loading = false);
        }

        $onInit(): void {
            this.loadNewAccountLifeCycle();
        }
    }

    class SalesforceCaseTrackerSummaryAdvisor implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
            };
            this.controller = SalesforceCaseTrackerSummaryAdvisorController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/salesforce-case-tracker-summary-advisor.html";
        }
    }
    angular.module(Constants.APP).component("salesforceCaseTrackerSummaryAdvisor", new SalesforceCaseTrackerSummaryAdvisor());
}
